import { detectOrderSummaryScroll, toggleOrderSummary } from './utils/handleOrderSummary';
import { toggleFormRow } from './utils/toggleFormRows';
import { setupCharCounters } from '../utils/setupCharCounters';

/**
 * Sets up all event listeners needed for the checkout page after the DOM is fully loaded.
 */
export function initialiseCheckoutListeners(): void {
	document.addEventListener('DOMContentLoaded', function () {
		/** Order Summary Handlers **/
		toggleOrderSummary();
		detectOrderSummaryScroll();
		window.addEventListener('resize', () => {
			toggleOrderSummary();
			detectOrderSummaryScroll();
		});

		/** Form Element Toggling **/
		const formToggles = document.querySelectorAll<HTMLElement>('[data-form-target]');

		formToggles.forEach((el) => {
			// Click (prevent navigation for <a> without href)
			el.addEventListener('click', (ev) => {
				if (el.tagName === 'A' && !(el as HTMLAnchorElement).hasAttribute('href'))
					ev.preventDefault();
				toggleFormRow(el);
			});

			// Keyboard: Enter / Space
			el.addEventListener('keydown', (ev: KeyboardEvent) => {
				const k = ev.key;
				if (k !== 'Enter' && k !== ' ' && k !== 'Spacebar') return;
				ev.preventDefault();
				toggleFormRow(el);
			});
		});

		/** Listen for and subsequently setup Character Counters **/
		const charCounterElems = document.querySelectorAll<HTMLInputElement>(
			'[data-char-counter-target]',
		);
		charCounterElems.forEach((el) => {
			setupCharCounters(el);
		});
	});
}
